import React from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import { requestConstants } from '../../constants';

const help = (applicationStatus) => {
  if (applicationStatus === requestConstants.status.SUBMITTED ||
      applicationStatus === requestConstants.status.APPROVED_PROVISIONALLY ||
      applicationStatus === requestConstants.status.APPROVED_LICENCE_PENDING) {

    return 'Awaiting Ofcom';
  }

  if (applicationStatus === requestConstants.status.REJECTED_PROVISIONALLY) {
    return 'Email Ofcom petitioning for consideration';
  }
  return null;
};

const ApplicationStatus = (props) => {
  const { application } = props;

  const helpText = help(application.status);

  if (!helpText) {
    return (application.status);
  }

  const popover = (
    <Popover>
      <Popover.Content>{helpText}</Popover.Content>
    </Popover>
  )

  return (
    <OverlayTrigger overlay={popover}>
      <span>
        {application.status}
        &nbsp;
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle mb-1" viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
          <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
        </svg>
      </span>
    </OverlayTrigger>
  )
};

export default ApplicationStatus;
